import { createFileRoute, redirect } from '@tanstack/react-router'

// «На закрытии» is no longer a standalone section — closing rentals live
// under «Текущие» behind the scope tab filter (nav Variant 2). The route
// stays as a redirect so old links and bookmarks keep working.
export const Route = createFileRoute('/_app/rent/closing')({
	beforeLoad: () => {
		throw redirect({ to: '/rent/active' })
	},
})
